import { Component, input } from '@angular/core';
import { DocumentFileSignedUrlPipe } from '../../pipes/document-file-signed-url-pipe';
import { DocumentResourceUrlPipe } from '../../pipes/document-resource-url-pipe';

@Component({
  selector: 'app-document-lma-embed',
  imports: [DocumentFileSignedUrlPipe, DocumentResourceUrlPipe],
  templateUrl: './document-lma-embed.html',
})
export class DocumentLmaEmbed {
  documentID = input.required<string>();
  organizationID = input.required<string>();
}
